export class UIMenuEntity {
  MenuId: number;
  FormId: number;
  ParentMenuId: number;
  Caption: string;
  Caption1: string;
  Caption2: string;
  Visible = false;
  Enabled = false;
  RoutingURL: string;
  Icon: string;
  SortOrder: number;
  Name: string;
  AuthorizationKey: Array<string>;
  SubModuleKey: Array<string>
  PermissionResourcekey: Array<string>;
}
